const twoColContentHandler = () => {
	const tabbedContentComponents = document.querySelectorAll(
		".tabbed-content-two-col__wrapper",
	);

	tabbedContentComponents.forEach((component) => {
		const triggers = component.querySelectorAll(
			".tabbed-content-two-col__trigger",
		);
		const contentColumn = component.querySelector(
			".tabbed-content-two-col__content-column",
		);

		const mobileTrigger = component.querySelector(
			".tabbed-content-two-col__mobile-select",
		);

		let currentContent = "arc-tab-item-0";

		const swapContent = () => {
			const triggerArray = component.querySelectorAll(
				".tabbed-content-two-col__trigger",
			);

			triggerArray.forEach((trigger) => {
				if (trigger.dataset.index === currentContent) {
					trigger.classList.add("tabbed-content-two-col__trigger-active");
				} else {
					trigger.classList.remove("tabbed-content-two-col__trigger-active");
				}
			});

			setContentHeight();
		};

		const setContentHeight = () => {
			const contentArray = contentColumn.querySelectorAll(
				".tabbed-content-two-col__content-wrapper",
			);
			contentArray.forEach((content) => {
				if (content.dataset.index === currentContent) {
					content.classList.add("tabbed-content-two-col__active");
					const contentGroup = content.querySelector(
						".tabbed-content-two-col__content",
					);
					// const currentHeight = contentGroup.scrollHeight;

					// contentArray.forEach((item) => {
					// 	item.style.maxHeight = `${currentHeight}px`;
					// });
				} else {
					content.classList.remove("tabbed-content-two-col__active");
				}
			});
		};

		setContentHeight();

		window.addEventListener("resize", setContentHeight);

		if (mobileTrigger) {
			mobileTrigger.addEventListener("change", () => {
				currentContent = mobileTrigger.value;
				swapContent();
			});
		}

		triggers.forEach((trigger) => {
			trigger.addEventListener("mouseover", () => {
				currentContent = trigger.dataset.index;
				swapContent();
				mobileTrigger.value = currentContent;
			});
		});
	});
};

if (document.readyState !== "loading") {
	twoColContentHandler();
} else {
	document.addEventListener("DOMContentLoaded", twoColContentHandler);
}
